import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_4: FaireProductEntity = {
  token: "legacy_prod_abbott-4",
  type: "product",
  name: "Green LED Pillar Candle 4x8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/41c2bf55adeed2b83f41600cbfdf8b72bf8ccc19238d140adb58015fd3623424.jpeg",
  priceDollars: 12,
  msrpDollars: 24,
  isBestseller: true,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
